export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/vc7dd53acf0c7d4d2338397c0e2aa9af548430c3d-runtime-main.c162236765b38937f14c.worker.js");
}
